import React, { useEffect, useRef } from "react";
import {
  CrossWrapper,
  Input,
  SearchBoxContainer,
  SearchIcon,
} from "./index.styled";
import { ReactComponent as Search } from "../../Assets/Icons/CategorySearch.svg";
import { ReactComponent as CrossSolid } from "../../Assets/Icons/CrossSolid.svg";

const HospitalComparisonSearch = ({
  placeholder = "Search Hospitals",
  searchTerm,
  setSearchTerm,
}) => {
  const inputRef = useRef(null);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  const handleClear = () => {
    setSearchTerm("");
  };

  return (
    <SearchBoxContainer onClick={(e) => e.stopPropagation()}>
      <Input
        ref={inputRef}
        id="search-input"
        type="text"
        placeholder={placeholder}
        value={searchTerm}
        autoComplete="off"
        autoCorrect="off"
        autoCapitalize="off"
        spellCheck="false"
        onChange={(e) => setSearchTerm(e.target.value)}
      />
      <SearchIcon>
        <Search />
      </SearchIcon>
      {searchTerm && (
        <CrossWrapper onClick={() => handleClear()}>
          <CrossSolid />
        </CrossWrapper>
      )}
    </SearchBoxContainer>
  );
};

export default HospitalComparisonSearch;
